import { GraphQlClient, Moment } from '@intelipost-js/secure-providers';
import { ScToast } from '@intelipost-js/secure-components';


export default {
  sendWebhook({ commit }, params) {
    commit('setLoading', true);
    const { createdDate, searchType, webhook } = params;
    const { start, end } = createdDate;

    let period = {
      startDate: Moment(start).format('YYYY-MM-DD'),
      endDate: Moment(end).format('YYYY-MM-DD'),
    };

    if (searchType !== 'PERIOD') {
      period = {};
    } else {
      Object.assign(params, { period });
    }

    if (webhook.authentication === 'NO AUTH') {
      webhook.authentication = 'BASIC';
    }

    return GraphQlClient.mutation(`
    mutation (
      $searchType: String,
      $macroStatus: String,
      $period: WebhookPeriod,
      $order: WebhookOrder,
      $batch: WebhookBatch,
      $webhook: WebhookData,
    ) {
      webhookSend(
        searchType: $searchType,
        macroStatus: $macroStatus
        period: $period
        order: $order
        batch: $batch
        webhook: $webhook
      ) {
          ok
        }
      }
    `, params)
    .then(() => {
      ScToast.success('Webhook enviado com sucesso');
      commit('setLoading', false);
    })
    .catch((err) => {
      commit('setLoading', false);
      return Promise.reject(err);
    });
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-order/features/webhook/store/actions.js